import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './core/layout/layout.module';
import { SidenavModule } from './core/layout/sidenav/sidenav.module';
import { CoreModule } from './core/shared/core.module';

@NgModule({
  imports: [BrowserModule, CommonModule, CoreModule, LayoutModule, AppRoutingModule, SidenavModule],
})
export class AppModule {}
